import { ServicesAndWarrantiesUI } from "./ServicesAndWarrantiesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { ServicesAndWarrantiesContextProvider } from "./ServicesAndWarrantiesContext";
import { VariantServices } from "../../types/types";
import { dispatchAnalyticsEvent } from "../../utils";
/**
 *
 * @deprecated use ExtendedWarranties and DeliveryServices instead
 */
export function ServicesAndWarranties({
  product,
  configProps,
}: Pick<StandardProps, "product" | "configProps">) {
  const { variant } = useVariant(product);
  const { services = [] } = variant;

  const servicesAndWarranties = services.filter(({ __typename }) =>
    ["DeliveryService", "ExtendedWarranty"].includes(__typename),
  ) as VariantServices;

  const hasServicesOrWarranties = (servicesAndWarranties ?? []).length > 0;

  const deliveryServiceQuestionnaireEnabled =
    (configProps?.deliveryServiceQuestionnaireEnabled as boolean) || false;

  const extendedWarrantiesAnalyticsHandler = (warrantyTitle: string) => {
    dispatchAnalyticsEvent(
      "pdp.modalUpdated",
      {
        type: "addToBasketService",
        services: [
          {
            price: variant.price?.value,
            productId: product.aliases.pimProductId,
            sku: variant.aliases.skuId,
            type: warrantyTitle,
          },
        ],
      },
      {},
    );
  };

  if (!hasServicesOrWarranties) return null;

  return (
    <ServicesAndWarrantiesContextProvider>
      <ServicesAndWarrantiesUI
        availableToOrder={variant?.availability?.availableToOrder || false}
        variantServices={servicesAndWarranties}
        deliveryServiceQuestionnaireEnabled={
          deliveryServiceQuestionnaireEnabled
        }
        extendedWarrantiesAnalyticsHandler={extendedWarrantiesAnalyticsHandler}
      />
    </ServicesAndWarrantiesContextProvider>
  );
}
